module.exports = __webpack_public_path__ + "static/img/Image-right.9c4015f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Image-right.png
// module id = 3SVp
// module chunks = 1